import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ClientsPage } from "@/features/clients/ClientsPage";

const search = z.object({
  tab: z.enum(["all", "client", "lead", "contact", "team"]).optional(),
  view: z.enum(["table", "cards", "list"]).optional(),
  peek: z.string().optional(),
  new: z.literal("1").optional(),
});

export const Route = createFileRoute("/_app/clients/")({
  validateSearch: search,
  component: () => <ClientsPage search={Route.useSearch()} />,
});
